export const IconLogin20: {
  name: 'icon_login_20-3d3d2525328f'
} = {
  name: 'icon_login_20-3d3d2525328f'
}
